/*global inputFocusHandler*/

import * as MathUtils from '../utils/MathUtils.js';

var __focusedControl = null;

export async function onFocusChangedAsync(sender, min, max, step) {

    __focusedControl = sender;

    if ((typeof inputFocusHandler !== "undefined") && (null !== inputFocusHandler)) {

        if ((undefined !== sender) && (null !== sender)) {
            inputFocusHandler.onFocusChanged(sender.id, sender.valueAsNumber,
                (min === undefined) || (min === null) ? null : parseFloat(min),
                (max === undefined) || (max === null) ? null : parseFloat(max),
                (step === undefined) || (step === null) ? null : parseFloat(step));
        }
        else {
            inputFocusHandler.onFocusLost();
        }

    }
}

export async function onValueChangedAsync(value) {

    if ((typeof inputFocusHandler !== "undefined") && (null !== inputFocusHandler)) {

        if ((undefined !== value) && (null !== value)) {
            //console.log('onValueChangedAsync value=' + value);
            inputFocusHandler.onValueChanged('', MathUtils.sanitiseNum(value));
        }

    }
}

export async function onStepChangedAsync(value) {

    if ((typeof inputFocusHandler !== "undefined") && (null !== inputFocusHandler)) {

        if ((undefined !== value) && (null !== value)) {
            console.log('onStepChangedAsync value=' + value);
            inputFocusHandler.onStepChanged('', MathUtils.sanitiseNum(value));
        }

    }
}

export function setFocusedValue(value) {

    if ((undefined !== __focusedControl) && (null !== __focusedControl)) {

        value = MathUtils.sanitiseNum(value);

        if (__focusedControl.valueAsNumber !== value) {

            // console.log(`setFocusedValue : ${__focusedControl.valueAsNumber} --> ${value}`);

            if ((undefined !== __focusedControl.inputHandlerChange) && (null !== __focusedControl.inputHandlerChange)) {
                __focusedControl.inputHandlerChange(value);
            }

        }
        else {

            // console.log(`setFocusedValue : ${__focusedControl.valueAsNumber} --> ${value} : IGNORED`);

        }
    }
}
